import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { ErrorIcon } from '@/assets/icons/error';
import { Box } from '@/components/lib/components';
import { useAlerts } from '@/feature/alerts/hooks/use-alerts';
import { useIsPredictionsProduct } from '@/hooks/use-is-predictions-product';

export const useBetRejectedAlert = () => {
    const { t } = useTranslation(['betslip_sbk', 'common']);
    const { showInfoSheet } = useAlerts();
    const isPredictions = useIsPredictionsProduct();
    const showBetRejectedAlert = useCallback(() => {
        showInfoSheet({
            title: t(isPredictions ? 'trade_rejected' : 'entry_rejected'),
            description: t(isPredictions ? 'trade_place_error_fallback' : 'place_error_fallback'),
            buttonLabel: t('common:close'),
            icon: (
                <Box mt="s16">
                    <ErrorIcon />
                </Box>
            ),
        });
    }, [showInfoSheet, t, isPredictions]);
    return { showBetRejectedAlert };
};
